export default {
  roulette: {
    isModalShown: false,
    isRouletteShown: false,
    amountOfRewardsAllowedToSelect: 3
  },
  rewards: [
    {
      id: 1,
      title: "Day off",
      image: "dayoff.jpg",
      selected: false
    },
    {
      id: 2,
      title: "Wellness",
      image: "wellness.jpg",
      selected: false
    },
    {
      id: 3,
      title: "Speedy gonzales",
      image: "speedy-gonzales.jpg",
      selected: false
    },
    {
      id: 4,
      title: "Fancy dinner",
      image: "fancy-dinner.jpg",
      selected: false
    },
    {
      id: 5,
      title: "Escaperoom with the team",
      image: "escape-room.jpg",
      selected: false
    },
    {
      id: 6,
      title: "Bon adrenaline voor 2",
      image: "adrenaline.jpg",
      selected: false
    },
    {
      id: 7,
      title: "Massage@work",
      image: "massage.jpg",
      selected: false
    },
    {
      id: 8,
      title: "Baristacursus",
      image: "barista.jpg",
      selected: false
    },
    {
      id: 9,
      title: "Yoga@work",
      image: "yoga.jpg",
      selected: false
    },
    {
      id: 10,
      title: "Wine/beer tasting with the team",
      image: "tasting.jpg",
      selected: false
    },
    {
      id: 11,
      title: "Subscription on Netflix/Spotify for a year",
      image: "netflix.jpg",
      selected: false
    },
    {
      id: 12,
      title: "Charity donation",
      image: "donation.jpg",
      selected: false
    },
    {
      id: 13,
      title: "Subscription for the ZOO",
      image: "zoo.jpg",
      selected: false
    }
  ]
};



/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/